<template>
  <vv-desktop-taste-tile
    :title="bottle && bottle.title ? bottle.title : ''"
    :image="bottle.image"
    :ratingPath="tastingId"
    :bottleId="bottle.id"
    :status="status"
    @click="openTasting"
    v-if="$mq == 'desktop'"
  />
  <vv-mobile-taste-tile
    :title="bottle && bottle.title ? bottle.title : ''"
    :image="bottle.image"
    :ratingPath="tastingId"
    :bottleId="bottle.id"
    :status="status"
    @click="openTasting"
    v-else
  />
</template>

<script>
import get from 'lodash/get'

import VvMobileTasteTile from '@/components/common/VvMobileTasteTile'
import VvDesktopTasteTile from '@/components/common/VvDesktopTasteTile'

export default {
  name: 'TastingListItem',
  components: { VvMobileTasteTile, VvDesktopTasteTile },
  props: {
    tastingId: {
      type: String,
      required: true
    },
    bottle: {
      type: Object,
      required: true
    },
    rating: {
      type: Number,
      required: true
    }
  },
  computed: {
    ratingpath() {
      return "tasting/" + this.tastingId + "/rating"
    },
    status() {
      const status = get(this.$store, ['state', 'completion', 'tasting', this.tastingId], null)
      return status
    }
  },
  methods: {
    openTasting() {
      this.$router.push({ name: 'tasting-funnel', params: { tastingId: this.tastingId } })
    }
  }
}
</script>
